<template>
  <div>
    <h2 class="sec-title ml-8">Campaign Setup</h2>
    <div class="form-wrapper ma-8">
      <form class="form">
        <div class="form-group">
          <label for="campaignName" class="tit"
            >Campaign Name <span class="required">*</span></label
          >
          <input
            type="text"
            id="campaignName"
            placeholder="Type Your Campaign Name"
            v-model="store.campaignName"
          />
        </div>

        <div class="form-group">
          <label class="tit" for="campaignObjective">Campaign objective</label>
          <input
            type="text"
            id="campaignObjective"
            placeholder="Type Your Campaign Objective"
            value="Video views"
            style="color: #333333"
            readonly
          />
        </div>

        <div class="form-group2">
          <label class="tit">Budget <span class="required">*</span></label>
          <div class="platform-budgets">
            <div
              class="platform-card"
              v-for="(platform, index) in platforms"
              :key="platform.name"
              :class="{
                blurred: platform.name === 'Meta' && store.disableMeta,
              }"
            >
              <div class="platform-header">
                <img :src="platform.icon" class="icon" />
                {{ platform.name }}
              </div>

              <div class="radio-options my-3 d-flex justify-space-between">
                <span>
                  <input
                    type="radio"
                    :name="'budgetType_' + index"
                    value="daily"
                    v-model="platform.budgetType"
                  />
                  Daily
                </span>
                <span>
                  <input
                    type="radio"
                    :name="'budgetType_' + index"
                    value="lifetime"
                    v-model="platform.budgetType"
                  />
                  Life time
                </span>
              </div>

              <div class="currency-input">
                <input v-model="platform.amount" type="number" min="0" />
                <span>{{ platform.currency }}</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="form-group">
            <label for="startDate" class="tit"
              >Start date <span class="required">*</span></label
            >
            <DateRangePicker id="startDate" v-model="store.startDate" />
          </div>
          <div class="form-group">
            <label for="endDate" class="tit">End date <span class="required">*</span></label>
            <DateRangePicker id="endDate" v-model="store.endDate" />
          </div>
        </div>

        <div class="form-group sd status">
          <label class="tit">Status <span class="required">*</span></label>
          <div class="toggle-wrapper">
            <input type="checkbox" id="status" v-model="store.status" />
            <label for="status" class="toggle-label">
              <span class="circle"></span>
            </label>
            <span class="status-text">{{
              store.status ? "Active" : "Disabled"
            }}</span>
          </div>
        </div>

        <div class="form-footer">
          <button type="button" class="btn-next" @click="handleNextClick">
            Next
          </button>
        </div>
        <!-- عرض الأخطاء -->
        <div v-if="errors.length" class="error-messages">
          <p v-for="(e, i) in errors" :key="i" class="error-text">⚠ {{ e }}</p>
        </div>
      </form>
      <button></button>
      {{}}
    </div>
  </div>
</template>

<script>
import DateRangePicker from "./DateRangePicker.vue";
import { useSuperAddStore } from "@/store/superAddStore";

export default {
  name: "VedioViews",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      store: useSuperAddStore(),
      errors: [],
    };
  },
  computed: {
    platforms() {
      return this.store.platforms;
    },
    budgets() {
      return this.platforms.map((p) => ({
        name: p.name,
        amount: p.amount,
        currency: p.currency,
        budgetType: p.budgetType,
      }));
    },
  },
  methods: {
    updateBudget(index, val) {
      const platform = this.store.platforms[index];
      platform.budget = val;

      // ✅ فقط لو Meta، نحدد إذا كنا هنعمل disable بعدين في Step 2
      if (platform.name === "Meta") {
        const isValidVal = val && !isNaN(Number(val)) && Number(val) > 0;
        this.store.disableMeta = isValidVal;
        console.log("✅ disableMeta set to", this.store.disableMeta);
      }
    },
    validateForm() {
      this.errors = [];

      if (!this.store.campaignName.trim()) {
        this.errors.push("Campaign name is required");
      }

      const hasEmptyBudget = this.store.platforms.some((p) => {
        // تجاهل Meta لو مش مختارة أصلاً
        if (
          p.name === "Meta" &&
          (!this.store.selectedAccounts?.facebook ||
            this.store.selectedAccounts.facebook === null)
        ) {
          return false;
        }

        return !p.amount || isNaN(Number(p.amount));
      });

      if (hasEmptyBudget) {
        this.errors.push("All platforms must have a valid numeric budget");
      }

      if (!this.store.startDate) {
        this.errors.push("Start date is required");
      }
      if (!this.store.endDate) {
        this.errors.push("End date is required");
      }
      if (this.store.endDate) {
        const start = new Date(this.store.startDate);
        const end = new Date(this.store.endDate);
        if (end <= start) {
          this.errors.push("End date must be after the start date");
        }
      }

      return this.errors.length === 0;
    },
    handleNextClick() {
      if (this.validateForm()) {
        const data = {
          campaignName: this.store.campaignName,
          campaignObjective: this.store.campaignObjective,
          status: this.store.status,
          startDate: this.store.startDate,
          endDate: this.store.endDate,
          platforms: this.store.platforms,
        };

        this.store.setCampaignData(data); // نحفظ الداتا
        this.$emit("next"); // نكمل التنقل
      }
    },
  },
  mounted() {
    if (!this.store.selectedAccounts?.facebook) {
      this.store.disableMeta = false;
    }
    this.platforms.forEach((platform) => {
      if (!platform.budgetType) {
        platform.budgetType = "daily";
      }
    });
  },
};
</script>

<style scoped>
.sec-title {
  font-size: 20px;
  font-weight: 700;
}
.form-wrapper {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(102, 102, 102, 0.12);
  margin: auto;
}

.form-group {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
}
.form-group2 {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.tit {
  font-weight: 600;
  margin-bottom: 0.5rem;
  min-width: 14rem !important;
}

.required {
  color: red;
}

input[type="text"],
input[type="date"] {
  padding: 0.7rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

.budget-boxes {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.budget-card {
  border: 1px solid #eee;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  flex: 1;
  min-width: 200px;
  position: relative;
}

.platform-header {
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  background: #f2f2f2;
  gap: 0.8rem;
  padding: 0.5rem;
  border-radius: 0.3rem;
}

.icon {
  width: 20px;
  height: 20px;
}

.currency {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  color: gray;
  font-size: 0.8rem;
}

.form-row {
  display: flex;
  gap: 1rem;
}

.status {
  display: flex;
  align-items: center;
}

.toggle-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.toggle-label {
  width: 40px;
  height: 22px;
  background: #ccc;
  border-radius: 12px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"]:checked + .toggle-label {
  background: #237276;
}

.toggle-label .circle {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 2px;
  left: 2px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s;
}

input[type="checkbox"]:checked + .toggle-label .circle {
  transform: translateX(18px);
}

.status-text {
  font-weight: 500;
  color: #333333;
}

.form-footer {
  text-align: right;
}

.btn-next {
  background-color: #207878;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 6rem;
}
.custom-date-input {
  background-color: #f9f9f9;
  border-radius: 8px;
  width: 100%;
}

.custom-date-input .v-field {
  min-height: 44px;
  font-size: 14px;
}

.custom-date-input input {
  font-weight: 500;
  padding: 10px 12px;
}

.custom-date-input .v-icon {
  color: #207878;
}
.error-text {
  color: red;
}
.platform-budgets {
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
  flex-wrap: wrap;
}

.platform-card {
  border: 1px solid #eee;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  flex: 1;
  min-width: 200px;
  position: relative;
}
#startDate,
#endDate {
  width: 100%;
  border: 1px solid #ccc;
  padding: 0.5rem;
  border-radius: 11px;
}
.currency-input {
  display: flex;
  align-items: center;
  border: 1.5px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 14px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  font-size: 15px;
}

.currency-input input {
  flex: 1;
  border: none;
  outline: none;
  font-size: inherit;
  padding: 10px 0;
  background: transparent;
  min-width: 0;
  appearance: textfield;
}

.currency-input input::-webkit-outer-spin-button,
.currency-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.currency-input span {
  color: #555;
  white-space: nowrap;
  margin-left: 10px;
  font-weight: 500;
}
input[type="radio"]:checked {
  accent-color: #237276;
}
.radio-options input[type="radio"] {
  margin-right: 4px;
}

.radio-options span {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #333;
  gap: 4px;
}
</style>
